import { render, staticRenderFns } from "./header.component.vue?vue&type=template&id=23daf67a"
import script from "./header.component.ts?vue&type=script&lang=ts&external"
export * from "./header.component.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/foex-3r/foex-3r-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('23daf67a')) {
      api.createRecord('23daf67a', component.options)
    } else {
      api.reload('23daf67a', component.options)
    }
    module.hot.accept("./header.component.vue?vue&type=template&id=23daf67a", function () {
      api.rerender('23daf67a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/client/site/header.component.vue"
export default component.exports